import { render } from "./esclusioneOrariModal.vue?vue&type=template&id=6a393f3d&ts=true"
import script from "./esclusioneOrariModal.vue?vue&type=script&lang=ts"
export * from "./esclusioneOrariModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__